// Mural de novidades da ferramenta (pedido do Thiago em 29/10/2026: "Eu não sabia disso.
// Tem que ter um mural de notícias da ferramenta"). Entra aqui tudo o que muda o trabalho
// da equipe, no mesmo PR que publica a mudança. Mais nova primeiro; o `id` nunca muda
// (é o que marca a novidade como vista).

export type Novidade = {
  id: string;
  /** AAAA-MM-DD, dia em que entrou no ar */
  data: string;
  titulo: string;
  /** o que mudou, em frases curtas */
  itens: string[];
  /** onde fica / como usar */
  comoUsar?: string;
};

export const NOVIDADES: Novidade[] = [
  {
    id: "2026-11-04-reconferir-acesso",
    data: "2026-11-04",
    titulo: "Botão para reconferir o acesso ao Google na hora",
    itens: [
      "Depois de tirar ou devolver o acesso de uma ficha no Google, não precisa mais esperar a leitura das 7h.",
      "Se a nossa conta não enxerga mais a ficha, ela fica Sem acesso e sai do Monitoramento.",
      "Se a ficha mudou para outra conta nossa, o perfil é ligado à conta nova sozinho.",
    ],
    comoUsar: "Monitoramento › ícone de escudo na linha do perfil. Para trazer de volta uma ficha Sem acesso: Mais filtros › Acesso ao Google › Só sem acesso, e use o mesmo ícone.",
  },
  {
    id: "2026-11-03-descricao-750",
    data: "2026-11-03",
    titulo: "Descrição do negócio: o limite do Google é 750 caracteres",
    itens: [
      "O editor dizia \"até 2.000\", mas o Google só aceita 750 caracteres. Acima disso aparecia \"Failed to update profile: Request contains an invalid argument\".",
      "Agora o contador mostra 750, avisa quanto passou e não deixa salvar até cortar.",
    ],
    comoUsar: "Perfil › Descrição. Se aparecer o aviso, corte o número de caracteres indicado e salve de novo.",
  },
  {
    id: "2026-10-29-encerramento-com-aprovacao",
    data: "2026-10-29",
    titulo: "Encerrar impulsionamento agora precisa de aprovação",
    itens: [
      "Quem aprova: Thiago, Igor, Ana Paula e Roberta. Quando um deles pede, o encerramento já começa.",
      "Pedido de outra pessoa fica \"Aguardando aprovação\" e nada muda no perfil até alguém aprovar.",
      "O nosso acesso de gestor não sai mais por padrão. Só Reinaldo, Thiago, Roberta, Ana Paula e Igor podem marcar essa opção.",
      "Fica registrado quem pediu, quem aprovou ou recusou e quando.",
      "Atenção: \"Cancelar o que falta\" não reativa o perfil. Perfil encerrado não posta nem responde avaliação. Para reativar, peça no grupo.",
    ],
    comoUsar:
      "Pedidos aguardando aparecem no topo do Monitoramento para quem aprova. No perfil, o botão \"Encerrar impulsionamento\" mostra o pedido e os botões Aprovar e Recusar.",
  },
  {
    id: "2026-10-29-minisite-foto-quebrada",
    data: "2026-10-29",
    titulo: "Mini-site não mostra mais foto quebrada",
    itens: [
      "Foto do Google que não abre mais (link expirado) sai da galeria \"Nosso trabalho\".",
      "Se nenhuma foto abrir, a seção some até o perfil ter foto boa.",
    ],
    comoUsar: "Para a galeria voltar, suba fotos novas no perfil do Google do cliente. A leitura diária traz elas para o mini-site.",
  },
  {
    id: "2026-10-29-email-ja-cadastrado",
    data: "2026-10-29",
    titulo: "\"E-mail já cadastrado\" agora diz onde está a conta",
    itens: [
      "A mensagem mostra o nome, o tipo e a situação de quem já usa o e-mail.",
      "Conta criada quando alguém entra com o Google vira Cliente e não aparece na Equipe sem o filtro.",
    ],
    comoUsar: "Equipe e acessos › Mais filtros › Nível › Cliente, busque o e-mail e edite a conta para trocar a função.",
  },
  {
    id: "2026-10-28-total-de-avaliacoes",
    data: "2026-10-28",
    titulo: "Total e nota de avaliações iguais aos do Google",
    itens: [
      "O mini-site e o painel mostram o total e a nota que o Google informa, não só as avaliações importadas.",
      "O número é atualizado na leitura das 7h.",
    ],
  },
  {
    id: "2026-10-28-monitoramento-sem-acesso",
    data: "2026-10-28",
    titulo: "Monitoramento sem fichas que perdemos no Google",
    itens: [
      "Ficha em que a nossa conta não tem mais acesso sai do Monitoramento e da busca.",
      "Para ver só essas fichas (por exemplo, para pedir o acesso de novo), use o filtro de acesso.",
    ],
    comoUsar: "Monitoramento › Mais filtros › Acesso ao Google › Só sem acesso.",
  },
  {
    id: "2026-10-13-encerrar-impulsionamento",
    data: "2026-10-13",
    titulo: "Botão \"Encerrar impulsionamento\" para cliente que cancela",
    itens: [
      "Apaga do Google o que o GeoRanking fez: postagens, respostas às avaliações, descrição e serviços.",
      "As categorias adicionais saem e a principal vira \"Serviço de empresa para empresa\".",
      "Produtos são apagados pelo robô em até 48 h.",
      "O que é apagado não volta. Guardamos uma cópia de tudo antes.",
    ],
    comoUsar: "No perfil, abaixo das abas. É preciso digitar o nome da empresa para confirmar.",
  },
  {
    id: "2026-10-12-whatsapp-e-recusadas",
    data: "2026-10-12",
    titulo: "WhatsApp na ficha e respostas recusadas refeitas",
    itens: [
      "O editor do perfil tem o bloco \"WhatsApp no Google\". A leitura de toda noite traz o WhatsApp de cada ficha.",
      "Resposta a avaliação recusada pelo Google é refeita automaticamente, já corrigindo o motivo da recusa.",
      "Reservas e cardápio aparecem no painel e no relatório quando o perfil tem.",
      "O mini-site conta os cliques dos botões.",
    ],
  },
  {
    id: "2026-10-08-fotos-viram-jpg",
    data: "2026-10-08",
    titulo: "Fotos convertidas para o formato do Google no envio",
    itens: [
      "Foto do Gabarito, das Postagens e dos Produtos em WebP, AVIF ou GIF vira JPG ao subir. Foto pequena é ampliada.",
      "Antes, uma foto WebP fazia o perfil ficar dias sem postar.",
      "Foto HEIC do iPhone só converte no Safari. Em outro navegador, exporte como JPG.",
    ],
  },
];
